import { useAtom } from "jotai";
import { useCallback } from "react";
import Select from "react-select";

import {
  currentQuestionIndexAtom,
  landerQuizQuestionAtom,
} from "../../../lander-quiz.state";
import { QuestionTitle } from "../../shared/question-title/question-title.component";

export const SelectorQuestion: React.FC = () => {
  const [currentQuestionIndex] = useAtom(currentQuestionIndexAtom);
  const [currentQuestion, setCurrentQuestion] = useAtom(
    landerQuizQuestionAtom(currentQuestionIndex)
  );

  const handleSelectorChange = useCallback(
    (e) => {
      setCurrentQuestion({
        ...currentQuestion,
        answer: e.value,
      });
    },
    [currentQuestion, setCurrentQuestion]
  );

  return (
    <div className={"selector-question"}>
      <QuestionTitle title={currentQuestion.title} />
      <div className="selector-question__selector-container">
        <Select
          menuPlacement={"auto"}
          menuPosition={"fixed"}
          isSearchable={false}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              border: "1px solid #d5d5d5",
              boxShadow: "none",
              "&:hover": {
                border: "1px solid #d5d5d5",
              },
            }),
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary25: "#eeeeee",
              primary50: "#eeeeee",
              primary: "black",
            },
          })}
          components={{
            IndicatorSeparator: () => null,
          }}
          className="selector-question__selector"
          placeholder={"Select an option..."}
          onChange={handleSelectorChange}
          options={currentQuestion.options?.map((option) => {
            return { value: option.label, label: option.label };
          })}
        />
      </div>
    </div>
  );
};
